import { isStatusValid } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta14Model } from './model-consultaSeguimentoPergunta14'
import {
  hasPergunta14OlhaSeusOlhosAtLeastTwoSim,
  isPergunta14OlhaSeusOlhosAllFilled,
  isPergunta14OlhaSeusOlhosAllNao,
} from './utils-consultaSeguimentoPergunta14'

export const validatorConsultaSeguimentoPergunta14 = createValidator<ConsultaSeguimentoPergunta14Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_14_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta14Model, errors: ErrorObject<ConsultaSeguimentoPergunta14Model>) => {
    if (values?.PERGUNTA_14_HEADER === SimNaoEnum.SIM) {
      errors.PERGUNTA_14_DEU_EXEMPLO_ABAIXO = required(values?.PERGUNTA_14_DEU_EXEMPLO_ABAIXO)
    }

    if (values?.PERGUNTA_14_HEADER === SimNaoEnum.NAO || values?.PERGUNTA_14_DEU_EXEMPLO_ABAIXO === SimNaoEnum.NAO) {
      const isNotOlhaSeusOlhosAtLeastTwoSim = !hasPergunta14OlhaSeusOlhosAtLeastTwoSim(
        values?.PERGUNTA_14_OLHA_SEUS_OLHOS
      )

      if (isNotOlhaSeusOlhosAtLeastTwoSim) {
        errors.PERGUNTA_14_OLHA_SEUS_OLHOS = createValidator<
          ConsultaSeguimentoPergunta14Model['PERGUNTA_14_OLHA_SEUS_OLHOS']
        >({
          PRECISA_DE_ALGUMA_COISA: required,
          BRINCANDO: required,
          ALIMENTACAO: required,
          TROCA_FRALDAS: required,
          LENDO_HISTORIA: required,
          FALANDO: required,
        })(values?.PERGUNTA_14_OLHA_SEUS_OLHOS)

        if (
          isPergunta14OlhaSeusOlhosAllFilled(values?.PERGUNTA_14_OLHA_SEUS_OLHOS) &&
          !isPergunta14OlhaSeusOlhosAllNao(values?.PERGUNTA_14_OLHA_SEUS_OLHOS)
        ) {
          errors.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS = required(values?.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS)

          if (values?.PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS === SimNaoEnum.SIM) {
            errors.PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES = required(values?.PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES)
          }
        }
      }
    }
    return errors
  }
)
